import React from 'react';
import { TableRow, TableCell, Typography, Avatar, Box } from '@mui/material';
import { ITeamMember } from '@types';
import { TeamMember } from './TeamMember';
import { format } from 'date-fns';
import { TeamsTableHeader } from '../constants/headers';
import { navRailBreakpoint } from '@theme/variables';
import { isSowEndingSoon } from './helpers';

type Props = {
  member: ITeamMember & { deliveryManager: ITeamMember };
  projectId: string;
  isLast: boolean;
  visibleHeaders: TeamsTableHeader[];
};

export const MemberRow: React.FC<Props> = ({
  member,
  projectId,
  isLast = false,
  visibleHeaders,
}) => (
  <TableRow
    sx={{
      '& td': {
        borderBottom: isLast ? 'none' : undefined,
        px: { [navRailBreakpoint]: '12px' },
      },
    }}
  >
    {visibleHeaders.includes(TeamsTableHeader.ProjectTeamMember) && (
      <TableCell>
        <TeamMember teamMember={member} projectId={projectId} />
      </TableCell>
    )}

    {visibleHeaders.includes(TeamsTableHeader.DeliveryManager) && (
      <TableCell>
        {member.deliveryManager && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Avatar
              sx={{ width: 24, height: 24 }}
              src={member.deliveryManager.avatarUrl}
            />
            <Typography variant="body2">
              {member.deliveryManager.fullName}
            </Typography>
          </Box>
        )}
      </TableCell>
    )}

    {visibleHeaders.includes(TeamsTableHeader.SowStartDate) && (
      <TableCell>
        <Typography color="text.disabled">
          {member.startedAt
            ? format(new Date(member.startedAt), 'M/d/yyyy')
            : '-'}
        </Typography>
      </TableCell>
    )}

    {visibleHeaders.includes(TeamsTableHeader.SowEndDate) && (
      <TableCell>
        <Typography
          color={
            isSowEndingSoon(member.endedAt) ? 'error.main' : 'text.disabled'
          }
        >
          {member.endedAt ? format(new Date(member.endedAt), 'M/d/yyyy') : '-'}
        </Typography>
      </TableCell>
    )}

    {visibleHeaders.includes(TeamsTableHeader.NextEvaluation) && (
      <TableCell>
        <Typography color="text.disabled">
          {member.evaluations && member.evaluations[0]
            ? format(member.evaluations[0].evaluationDate, 'MMMM yyyy')
            : '-'}
        </Typography>
      </TableCell>
    )}

    {visibleHeaders.includes(TeamsTableHeader.Rate) && (
      <TableCell>
        <Typography component="span" color="text.disabled">
          $
        </Typography>
        {member.rate}
      </TableCell>
    )}

    {visibleHeaders.includes(TeamsTableHeader.Allocation) && (
      <TableCell>{`${member.allocation}%`}</TableCell>
    )}
  </TableRow>
);
